import { Hidden, useMediaQuery } from "@material-ui/core"
import type { FC } from "react"
import { Theme } from "theme/theme"

export type MediaQueryComponentProps = {
  aboveTheFold?: boolean
}

export const useCustomQuery = (minWidth: number) =>
  useMediaQuery(`(min-width:${minWidth}px)`)

export const useIsDesktop = () =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.up("md"))

export const Mobile: FC<MediaQueryComponentProps> = ({
  children,
  aboveTheFold = false,
}) => (
  <Hidden implementation={aboveTheFold ? "css" : "js"} mdUp>
    {children}
  </Hidden>
)

export const Desktop: FC<MediaQueryComponentProps> = ({
  children,
  aboveTheFold = false,
}) => (
  <Hidden implementation={aboveTheFold ? "css" : "js"} smDown>
    {children}
  </Hidden>
)

export const MediumScreen: FC<MediaQueryComponentProps> = ({
  children,
  aboveTheFold = false,
}) => (
  <Hidden
    implementation={aboveTheFold ? "css" : "js"}
    only={["xs", "sm", "xl"]}
  >
    {children}
  </Hidden>
)

export const LargeScreen: FC<MediaQueryComponentProps> = ({
  children,
  aboveTheFold = false,
}) => (
  <Hidden implementation={aboveTheFold ? "css" : "js"} lgDown>
    {children}
  </Hidden>
)

export const IEMediaQuery =
  "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)"

export const EdgeMediaQuery = "@supports (-ms-ime-align:auto)"
